/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAgencyClientBrandModel } from './userAgencyClientBrandModel';


export interface UserAgencyClientModel { 
    _id: string;
    name: string;
    brands: Array<UserAgencyClientBrandModel>;
}

